import React, {
  lazy, Suspense, useEffect, useState,
} from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { parseHtml } from '../../utils/util';

const SingpassProvider = lazy(() => import('@americanexpress/axp-singpass-myinfo-ui-widget'));

const Singpass = ({
  childProps,
  formSubmissionPayload,
  setFormSubmissionPayload,
  handleContinue,
  journeyId,
}) => {
  // API URL which is configured in root module
  const submitApiUrls = useSelector((state) => state.getIn(['config', 'singpassIntegrationUrls']));

  // page number to be redirected to once successful
  const { successCallBackPageIdentifier } = childProps.customTag.childPropsStatic;

  // In case user selects option to fill form manually - The Page number to redirect to
  const { manualFillPageIdentifier } = childProps.customTag.childPropsStatic;

  // // In case of any error - page to redirect
  // const { errorPageIdentifier } = childProps.customTag.childPropsStatic;

  // Language data for SINGPASS_MY_INFO_COMPONENT
  const { languageData } = childProps.customTag.childPropsStatic;

  const [languageDataUpdated, setLanguageDataUpdated] = useState({});

  useEffect(() => {
    if (languageData !== null && languageData !== undefined) {
      const tempLanguageDataUp = {};

      /** For each of the keys in language data provide */
      Object.keys(languageData).forEach((value) => {
        tempLanguageDataUp[value] = parseHtml(languageData[value]);
      });

      setLanguageDataUpdated(tempLanguageDataUp);
    }
  }, []);

  /**
   * Success callback handler - Once the data is received successfully this method is responsible
   * to add that data to form submission payload
   * @param {*} param0
   */
  const callbackHandlerFn = (personData) => {
    setFormSubmissionPayload({
      ...formSubmissionPayload, elemId: null, singpassPersonData: personData, sgMyInfoPresent: 'Y',
    });
  };

  /**
   * Handle Continue function is invoked from this method for the required page number
   * @param {*} page  - default to success page
   */
  const continueClickHandlerFn = (page = successCallBackPageIdentifier) => {
    setTimeout(() => {
      handleContinue(page);
    });
  };

  /**
   * In case user selects manual form filling -- this method is invoked
   */
  const manualFillHandlerFn = () => {
    setFormSubmissionPayload({ ...formSubmissionPayload, elemId: null, sgMyInfoPresent: 'N' });
    continueClickHandlerFn(manualFillPageIdentifier);
  };

  /**
   * Merged props to be passed to component
   */
  const mergedProps = {
    traceId: journeyId,
    ...childProps.customTag.childPropsStatic,
    languageData: languageDataUpdated,
    submitApiUrls,
    state: formSubmissionPayload.state,
    sgMyInfoCode: formSubmissionPayload.code,
    callbackHandlerFn,
    manualFillHandlerFn,
    continueClickHandlerFn,
  };

  return (
    <Suspense fallback="Please wait....">
      <SingpassProvider {...mergedProps} />
    </Suspense>
  );
};

Singpass.propTypes = {
  childProps: PropTypes.objectOf(PropTypes.shape),
  filledFormData: PropTypes.objectOf(PropTypes.shape),
  formSubmissionPayload: PropTypes.objectOf(PropTypes.shape),
  setFormSubmissionPayload: PropTypes.func,
  handleContinue: PropTypes.func,
  journeyId: PropTypes.string,
};

export default Singpass;
